import { styled } from "@mui/material/styles";

const StyledCartBadge = styled("div")(({ theme, value }) => ({
	position: "absolute",
	minWidth: 18,
	height: 18,
	top: -2,
	right: 0,
	borderRadius: 9,
	padding: "0 5px",
	fontSize: 11,
	textAlign: "center",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundColor: theme.palette.secondary.main,
	color: theme.palette.secondary.contrastText,
	boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.35)",
	zIndex: 10,
}));

const CartBadge = ({ children }) => {
	return <StyledCartBadge>{children}</StyledCartBadge>;
};

export default CartBadge;
